<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

import BranchForm from '../BranchForm.vue';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    BranchForm,
    PageHeader,
    Spinner,
  },
  data() {
    return {
      enabledFeatures: {},
    };
  },
  computed: {
    branchData() {
      const { branchId } = this.$route.params;
      return this.$store.getters['branches/getBranch'](branchId);
    },
    showBranchForm() {
      const { id } = this.branchData;
      return id && !this.uiFlags.isFetching;
    },
    ...mapGetters({
      uiFlags: 'branches/getUIFlags',
    }),
  },
  methods: {
    async updateBranch(data) {
      try {
        const { branchId } = this.$route.params;

        await this.$store.dispatch('branches/update', {
          id: branchId,
          ...data,
        });

        useAlert('Sucursal actualizada exitosamente');
        router.push({
          name: 'settings_branches_list',
        });
      } catch (error) {
        useAlert('Error al actualizar la sucursal');
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-8 col-span-6 overflow-y-auto">
    <PageHeader
      header-title="Editar sucursal"
      header-content="Modifica los datos de la sucursal"
    />
    <div class="flex flex-wrap">
      <BranchForm
        v-if="showBranchForm"
        :on-submit="updateBranch"
        :submit-in-progress="false"
        submit-button-text="Actualizar sucursal"
        :form-data="branchData"
      />
      <Spinner v-else />
    </div>
  </div>
</template>
